const constrainedWidth = 1200;
export const isConstrained = window.innerWidth < constrainedWidth;

// longest translation: sk-SK Zarezervovať teraz
const buyButtonConstrainedWidth = 768;
export const buyButtonIsConstrained = window.innerWidth < buyButtonConstrainedWidth;
